import { createFileRoute } from '@tanstack/react-router';

import { EmbedItemView } from '#/features/community-hub/components/block-viewers/embed-item-view';

/**
 * Embed item viewer. Path: /programs/{program}/{module}/{lesson}/embed/{itemSlug}
 * Shows an embed content block (URL iframe or sanitized HTML embed code)
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/embed/$itemSlug')({
  component: EmbedContentRoute,
});

function EmbedContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <EmbedItemView key={itemSlug} itemSlug={itemSlug} />;
}
